export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/Country',
		name: 'NbuCountry',
		title: {
			single: 'NbuCountry',
			plural: 'NbuCountries'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "11",
				"code": "036",
				"name": "АВСТРАЛІЯ",
				"caption": "АВСТРАЛІЯ",
				"isBlocked": false
			},
			{
				"id": "12",
				"code": "040",
				"name": "АВСТРІЯ",
				"caption": "АВСТРІЯ",
				"isBlocked": false
			},
			{
				"id": "9",
				"code": "031",
				"name": "АЗЕРБАЙДЖАН",
				"caption": "АЗЕРБАЙДЖАН",
				"isBlocked": false
			},
			{
				"id": "2",
				"code": "008",
				"name": "АЛБАНІЯ",
				"caption": "АЛБАНІЯ",
				"isBlocked": false
			},
			{
				"id": "4",
				"code": "012",
				"name": "АЛЖИР",
				"caption": "АЛЖИР",
				"isBlocked": false
			},
			{
				"id": "5",
				"code": "016",
				"name": "АМЕРИКАНСЬКЕ САМОА",
				"caption": "АМЕРИКАНСЬКЕ САМОА",
				"isBlocked": false
			},
			{
				"id": "184",
				"code": "660",
				"name": "АНГІЛЬЯ",
				"caption": "АНГІЛЬЯ",
				"isBlocked": false
			},
			{
				"id": "7",
				"code": "024",
				"name": "АНГОЛА",
				"caption": "АНГОЛА",
				"isBlocked": false
			},
			{
				"id": "6",
				"code": "020",
				"name": "АНДОРРА",
				"caption": "АНДОРРА",
				"isBlocked": false
			},
			{
				"id": "3",
				"code": "010",
				"name": "АНТАРКТИДА",
				"caption": "АНТАРКТИДА",
				"isBlocked": false
			},
			{
				"id": "8",
				"code": "028",
				"name": "АНТИГУА І БАРБУДА",
				"caption": "АНТИГУА І БАРБУДА",
				"isBlocked": false
			},
			{
				"id": "10",
				"code": "032",
				"name": "АРГЕНТИНА",
				"caption": "АРГЕНТИНА",
				"isBlocked": false
			},
			{
				"id": "150",
				"code": "533",
				"name": "АРУБА",
				"caption": "АРУБА",
				"isBlocked": false
			},
			{
				"id": "1",
				"code": "004",
				"name": "АФГАНІСТАН",
				"caption": "АФГАНІСТАН",
				"isBlocked": false
			},
			{
				"id": "13",
				"code": "044",
				"name": "БАГАМИ",
				"caption": "БАГАМИ",
				"isBlocked": false
			},
			{
				"id": "15",
				"code": "050",
				"name": "БАНГЛАДЕШ",
				"caption": "БАНГЛАДЕШ",
				"isBlocked": false
			},
			{
				"id": "17",
				"code": "052",
				"name": "БАРБАДОС",
				"caption": "БАРБАДОС",
				"isBlocked": false
			},
			{
				"id": "14",
				"code": "048",
				"name": "БАХРЕЙН",
				"caption": "БАХРЕЙН",
				"isBlocked": false
			},
			{
				"id": "26",
				"code": "084",
				"name": "БЕЛІЗ",
				"caption": "БЕЛІЗ",
				"isBlocked": false
			},
			{
				"id": "18",
				"code": "056",
				"name": "БЕЛЬГІЯ",
				"caption": "БЕЛЬГІЯ",
				"isBlocked": false
			},
			{
				"id": "59",
				"code": "204",
				"name": "БЕНІН",
				"caption": "БЕНІН",
				"isBlocked": false
			},
			{
				"id": "19",
				"code": "060",
				"name": "БЕРМУДИ",
				"caption": "БЕРМУДИ",
				"isBlocked": false
			},
			{
				"id": "34",
				"code": "112",
				"name": "БІЛОРУСЬ",
				"caption": "БІЛОРУСЬ",
				"isBlocked": false
			},
			{
				"id": "31",
				"code": "100",
				"name": "БОЛГАРІЯ",
				"caption": "БОЛГАРІЯ",
				"isBlocked": false
			},
			{
				"id": "21",
				"code": "068",
				"name": "БОЛІВІЯ",
				"caption": "БОЛІВІЯ",
				"isBlocked": false
			},
			{
				"id": "22",
				"code": "070",
				"name": "БОСНІЯ І ГЕРЦЕГОВИНА",
				"caption": "БОСНІЯ І ГЕРЦЕГОВИНА",
				"isBlocked": false
			},
			{
				"id": "23",
				"code": "072",
				"name": "БОТСВАНА",
				"caption": "БОТСВАНА",
				"isBlocked": false
			},
			{
				"id": "25",
				"code": "076",
				"name": "БРАЗИЛІЯ",
				"caption": "БРАЗИЛІЯ",
				"isBlocked": false
			},
			{
				"id": "27",
				"code": "086",
				"name": "БРИТАНСЬКА ТЕРИТОРІЯ В ІНДІЙСЬКОМУ ОКЕАНІ",
				"caption": "БРИТАНСЬКА ТЕРИТОРІЯ В ІНДІЙСЬКОМУ ОКЕАНІ",
				"isBlocked": false
			},
			{
				"id": "30",
				"code": "096",
				"name": "БРУНЕЙ-ДАРУССАЛАМ",
				"caption": "БРУНЕЙ-ДАРУССАЛАМ",
				"isBlocked": false
			},
			{
				"id": "230",
				"code": "854",
				"name": "БУРКІНА-ФАСО",
				"caption": "БУРКІНА-ФАСО",
				"isBlocked": false
			},
			{
				"id": "33",
				"code": "108",
				"name": "БУРУНДІ",
				"caption": "БУРУНДІ",
				"isBlocked": false
			},
			{
				"id": "20",
				"code": "064",
				"name": "БУТАН",
				"caption": "БУТАН",
				"isBlocked": false
			},
			{
				"id": "152",
				"code": "548",
				"name": "ВАНУАТУ",
				"caption": "ВАНУАТУ",
				"isBlocked": false
			},
			{
				"id": "233",
				"code": "862",
				"name": "ВЕНЕСУЕЛА",
				"caption": "ВЕНЕСУЕЛА",
				"isBlocked": false
			},
			{
				"id": "196",
				"code": "704",
				"name": "В'ЄТНАМ",
				"caption": "В'ЄТНАМ",
				"isBlocked": false
			},
			{
				"id": "29",
				"code": "092",
				"name": "ВІРГІНСЬКІ ОСТРОВИ, БРИТАНСЬКІ",
				"caption": "ВІРГІНСЬКІ ОСТРОВИ, БРИТАНСЬКІ",
				"isBlocked": false
			},
			{
				"id": "229",
				"code": "850",
				"name": "ВІРГІНСЬКІ ОСТРОВИ, США",
				"caption": "ВІРГІНСЬКІ ОСТРОВИ, США",
				"isBlocked": false
			},
			{
				"id": "16",
				"code": "051",
				"name": "ВІРМЕНІЯ",
				"caption": "ВІРМЕНІЯ",
				"isBlocked": false
			},
			{
				"id": "79",
				"code": "266",
				"name": "ГАБОН",
				"caption": "ГАБОН",
				"isBlocked": false
			},
			{
				"id": "94",
				"code": "332",
				"name": "ГАЇТІ",
				"caption": "ГАЇТІ",
				"isBlocked": false
			},
			{
				"id": "93",
				"code": "328",
				"name": "ГАЙАНА",
				"caption": "ГАЙАНА",
				"isBlocked": false
			},
			{
				"id": "81",
				"code": "270",
				"name": "ГАМБІЯ",
				"caption": "ГАМБІЯ",
				"isBlocked": false
			},
			{
				"id": "83",
				"code": "288",
				"name": "ГАНА",
				"caption": "ГАНА",
				"isBlocked": false
			},
			{
				"id": "89",
				"code": "312",
				"name": "ГВАДЕЛУПА",
				"caption": "ГВАДЕЛУПА",
				"isBlocked": false
			},
			{
				"id": "91",
				"code": "320",
				"name": "ГВАТЕМАЛА",
				"caption": "ГВАТЕМАЛА",
				"isBlocked": false
			},
			{
				"id": "92",
				"code": "324",
				"name": "ГВІНЕЯ",
				"caption": "ГВІНЕЯ",
				"isBlocked": false
			},
			{
				"id": "174",
				"code": "624",
				"name": "ГВІНЕЯ-БІСАУ",
				"caption": "ГВІНЕЯ-БІСАУ",
				"isBlocked": false
			},
			{
				"id": "84",
				"code": "292",
				"name": "ГІБРАЛТАР",
				"caption": "ГІБРАЛТАР",
				"isBlocked": false
			},
			{
				"id": "97",
				"code": "340",
				"name": "ГОНДУРАС",
				"caption": "ГОНДУРАС",
				"isBlocked": false
			},
			{
				"id": "98",
				"code": "344",
				"name": "ГОНКОНГ",
				"caption": "ГОНКОНГ",
				"isBlocked": false
			},
			{
				"id": "88",
				"code": "308",
				"name": "ГРЕНАДА",
				"caption": "ГРЕНАДА",
				"isBlocked": false
			},
			{
				"id": "87",
				"code": "304",
				"name": "ГРЕНЛАНДІЯ",
				"caption": "ГРЕНЛАНДІЯ",
				"isBlocked": false
			},
			{
				"id": "86",
				"code": "300",
				"name": "ГРЕЦІЯ",
				"caption": "ГРЕЦІЯ",
				"isBlocked": false
			},
			{
				"id": "80",
				"code": "268",
				"name": "ГРУЗІЯ",
				"caption": "ГРУЗІЯ",
				"isBlocked": false
			},
			{
				"id": "90",
				"code": "316",
				"name": "ГУАМ",
				"caption": "ГУАМ",
				"isBlocked": false
			},
			{
				"id": "60",
				"code": "208",
				"name": "ДАНІЯ",
				"caption": "ДАНІЯ",
				"isBlocked": false
			},
			{
				"id": "52",
				"code": "180",
				"name": "ДЕМОКРАТИЧНА  РЕСПУБЛІКА КОНГО",
				"caption": "ДЕМОКРАТИЧНА  РЕСПУБЛІКА КОНГО",
				"isBlocked": false
			},
			{
				"id": "78",
				"code": "262",
				"name": "ДЖІБУТІ",
				"caption": "ДЖІБУТІ",
				"isBlocked": false
			},
			{
				"id": "61",
				"code": "212",
				"name": "ДОМІНІКА",
				"caption": "ДОМІНІКА",
				"isBlocked": false
			},
			{
				"id": "62",
				"code": "214",
				"name": "ДОМІНІКАНСЬКА  РЕСПУБЛІКА",
				"caption": "ДОМІНІКАНСЬКА  РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "63",
				"code": "218",
				"name": "ЕКВАДОР",
				"caption": "ЕКВАДОР",
				"isBlocked": false
			},
			{
				"id": "65",
				"code": "226",
				"name": "ЕКВАТОРІАЛЬНА ГВІНЕЯ",
				"caption": "ЕКВАТОРІАЛЬНА ГВІНЕЯ",
				"isBlocked": false
			},
			{
				"id": "67",
				"code": "232",
				"name": "ЕРІТРЕЯ",
				"caption": "ЕРІТРЕЯ",
				"isBlocked": false
			},
			{
				"id": "68",
				"code": "233",
				"name": "ЕСТОНІЯ",
				"caption": "ЕСТОНІЯ",
				"isBlocked": false
			},
			{
				"id": "66",
				"code": "231",
				"name": "ЕФІОПІЯ",
				"caption": "ЕФІОПІЯ",
				"isBlocked": false
			},
			{
				"id": "225",
				"code": "818",
				"name": "ЄГИПЕТ",
				"caption": "ЄГИПЕТ",
				"isBlocked": false
			},
			{
				"id": "236",
				"code": "887",
				"name": "ЄМЕН",
				"caption": "ЄМЕН",
				"isBlocked": false
			},
			{
				"id": "238",
				"code": "894",
				"name": "ЗАМБІЯ",
				"caption": "ЗАМБІЯ",
				"isBlocked": false
			},
			{
				"id": "202",
				"code": "732",
				"name": "ЗАХІДНА САХАРА",
				"caption": "ЗАХІДНА САХАРА",
				"isBlocked": false
			},
			{
				"id": "200",
				"code": "716",
				"name": "ЗІМБАБВЕ",
				"caption": "ЗІМБАБВЕ",
				"isBlocked": false
			},
			{
				"id": "106",
				"code": "376",
				"name": "ІЗРАЇЛЬ",
				"caption": "ІЗРАЇЛЬ",
				"isBlocked": false
			},
			{
				"id": "101",
				"code": "356",
				"name": "ІНДІЯ",
				"caption": "ІНДІЯ",
				"isBlocked": false
			},
			{
				"id": "102",
				"code": "360",
				"name": "ІНДОНЕЗІЯ",
				"caption": "ІНДОНЕЗІЯ",
				"isBlocked": false
			},
			{
				"id": "104",
				"code": "368",
				"name": "ІРАК",
				"caption": "ІРАК",
				"isBlocked": false
			},
			{
				"id": "103",
				"code": "364",
				"name": "ІРАН,ІСЛАМСЬКА РЕСПУБЛІКА",
				"caption": "ІРАН,ІСЛАМСЬКА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "105",
				"code": "372",
				"name": "ІРЛАНДІЯ",
				"caption": "ІРЛАНДІЯ",
				"isBlocked": false
			},
			{
				"id": "100",
				"code": "352",
				"name": "ІСЛАНДІЯ",
				"caption": "ІСЛАНДІЯ",
				"isBlocked": false
			},
			{
				"id": "201",
				"code": "724",
				"name": "ІСПАНІЯ",
				"caption": "ІСПАНІЯ",
				"isBlocked": false
			},
			{
				"id": "107",
				"code": "380",
				"name": "ІТАЛІЯ",
				"caption": "ІТАЛІЯ",
				"isBlocked": false
			},
			{
				"id": "112",
				"code": "400",
				"name": "ЙОРДАНІЯ",
				"caption": "ЙОРДАНІЯ",
				"isBlocked": false
			},
			{
				"id": "38",
				"code": "132",
				"name": "КАБО-ВЕРДЕ",
				"caption": "КАБО-ВЕРДЕ",
				"isBlocked": false
			},
			{
				"id": "111",
				"code": "398",
				"name": "КАЗАХСТАН",
				"caption": "КАЗАХСТАН",
				"isBlocked": false
			},
			{
				"id": "35",
				"code": "116",
				"name": "КАМБОДЖА",
				"caption": "КАМБОДЖА",
				"isBlocked": false
			},
			{
				"id": "36",
				"code": "120",
				"name": "КАМЕРУН",
				"caption": "КАМЕРУН",
				"isBlocked": false
			},
			{
				"id": "37",
				"code": "124",
				"name": "КАНАДА",
				"caption": "КАНАДА",
				"isBlocked": false
			},
			{
				"id": "177",
				"code": "634",
				"name": "КАТАР",
				"caption": "КАТАР",
				"isBlocked": false
			},
			{
				"id": "113",
				"code": "404",
				"name": "КЕНІЯ",
				"caption": "КЕНІЯ",
				"isBlocked": false
			},
			{
				"id": "117",
				"code": "417",
				"name": "КИРГИЗСТАН",
				"caption": "КИРГИЗСТАН",
				"isBlocked": false
			},
			{
				"id": "44",
				"code": "156",
				"name": "КИТАЙ",
				"caption": "КИТАЙ",
				"isBlocked": false
			},
			{
				"id": "57",
				"code": "196",
				"name": "КІПР",
				"caption": "КІПР",
				"isBlocked": false
			},
			{
				"id": "85",
				"code": "296",
				"name": "КІРІБАТІ",
				"caption": "КІРІБАТІ",
				"isBlocked": false
			},
			{
				"id": "47",
				"code": "166",
				"name": "КОКОСОВІ (КІЛІНГ) ОСТРОВИ",
				"caption": "КОКОСОВІ (КІЛІНГ) ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "48",
				"code": "170",
				"name": "КОЛУМБІЯ",
				"caption": "КОЛУМБІЯ",
				"isBlocked": false
			},
			{
				"id": "49",
				"code": "174",
				"name": "КОМОРИ",
				"caption": "КОМОРИ",
				"isBlocked": false
			},
			{
				"id": "51",
				"code": "178",
				"name": "КОНГО",
				"caption": "КОНГО",
				"isBlocked": false
			},
			{
				"id": "114",
				"code": "408",
				"name": "КОРЕЙСЬКА НАРОДНО-ДЕМОКРАТИЧНА РЕСПУБЛІКА",
				"caption": "КОРЕЙСЬКА НАРОДНО-ДЕМОКРАТИЧНА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "115",
				"code": "410",
				"name": "КОРЕЯ, РЕСПУБЛІКА",
				"caption": "КОРЕЯ, РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "54",
				"code": "188",
				"name": "КОСТА-РИКА",
				"caption": "КОСТА-РИКА",
				"isBlocked": false
			},
			{
				"id": "108",
				"code": "384",
				"name": "КОТ-Д'ІВУАР",
				"caption": "КОТ-Д'ІВУАР",
				"isBlocked": false
			},
			{
				"id": "56",
				"code": "192",
				"name": "КУБА",
				"caption": "КУБА",
				"isBlocked": false
			},
			{
				"id": "116",
				"code": "414",
				"name": "КУВЕЙТ",
				"caption": "КУВЕЙТ",
				"isBlocked": false
			},
			{
				"id": "118",
				"code": "418",
				"name": "ЛАОСЬКА НАРОДНО-ДЕМОКРАТИЧНА РЕСПУБЛІКА",
				"caption": "ЛАОСЬКА НАРОДНО-ДЕМОКРАТИЧНА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "121",
				"code": "428",
				"name": "ЛАТВІЯ",
				"caption": "ЛАТВІЯ",
				"isBlocked": false
			},
			{
				"id": "120",
				"code": "426",
				"name": "ЛЕСОТО",
				"caption": "ЛЕСОТО",
				"isBlocked": false
			},
			{
				"id": "125",
				"code": "440",
				"name": "ЛИТВА",
				"caption": "ЛИТВА",
				"isBlocked": false
			},
			{
				"id": "122",
				"code": "430",
				"name": "ЛІБЕРІЯ",
				"caption": "ЛІБЕРІЯ",
				"isBlocked": false
			},
			{
				"id": "119",
				"code": "422",
				"name": "ЛІВАН",
				"caption": "ЛІВАН",
				"isBlocked": false
			},
			{
				"id": "123",
				"code": "434",
				"name": "ЛІВІЙСЬКА АРАБСЬКА ДЖАМАХІРІЯ",
				"caption": "ЛІВІЙСЬКА АРАБСЬКА ДЖАМАХІРІЯ",
				"isBlocked": false
			},
			{
				"id": "124",
				"code": "438",
				"name": "ЛІХТЕНШТЕЙН",
				"caption": "ЛІХТЕНШТЕЙН",
				"isBlocked": false
			},
			{
				"id": "126",
				"code": "442",
				"name": "ЛЮКСЕМБУРГ",
				"caption": "ЛЮКСЕМБУРГ",
				"isBlocked": false
			},
			{
				"id": "136",
				"code": "480",
				"name": "МАВРИКІЙ",
				"caption": "МАВРИКІЙ",
				"isBlocked": false
			},
			{
				"id": "135",
				"code": "478",
				"name": "МАВРИТАНІЯ",
				"caption": "МАВРИТАНІЯ",
				"isBlocked": false
			},
			{
				"id": "128",
				"code": "450",
				"name": "МАДАГАСКАР",
				"caption": "МАДАГАСКАР",
				"isBlocked": false
			},
			{
				"id": "50",
				"code": "175",
				"name": "МАЙОТТА",
				"caption": "МАЙОТТА",
				"isBlocked": false
			},
			{
				"id": "127",
				"code": "446",
				"name": "МАКАО",
				"caption": "МАКАО",
				"isBlocked": false
			},
			{
				"id": "224",
				"code": "807",
				"name": "МАКЕДОНІЯ, КОЛИШНЯ ЮГОСЛАВСЬКА РЕСПУБЛІКА",
				"caption": "МАКЕДОНІЯ, КОЛИШНЯ ЮГОСЛАВСЬКА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "129",
				"code": "454",
				"name": "МАЛАВІ",
				"caption": "МАЛАВІ",
				"isBlocked": false
			},
			{
				"id": "130",
				"code": "458",
				"name": "МАЛАЙЗІЯ",
				"caption": "МАЛАЙЗІЯ",
				"isBlocked": false
			},
			{
				"id": "132",
				"code": "466",
				"name": "МАЛІ",
				"caption": "МАЛІ",
				"isBlocked": false
			},
			{
				"id": "161",
				"code": "581",
				"name": "МАЛІ ВІДДАЛЕНІ ОСТРОВИ СПОЛУЧЕНИХ ШТАТІВ",
				"caption": "МАЛІ ВІДДАЛЕНІ ОСТРОВИ СПОЛУЧЕНИХ ШТАТІВ",
				"isBlocked": false
			},
			{
				"id": "131",
				"code": "462",
				"name": "МАЛЬДІВИ",
				"caption": "МАЛЬДІВИ",
				"isBlocked": false
			},
			{
				"id": "133",
				"code": "470",
				"name": "МАЛЬТА",
				"caption": "МАЛЬТА",
				"isBlocked": false
			},
			{
				"id": "142",
				"code": "504",
				"name": "МАРОККО",
				"caption": "МАРОККО",
				"isBlocked": false
			},
			{
				"id": "134",
				"code": "474",
				"name": "МАРТІНІКА",
				"caption": "МАРТІНІКА",
				"isBlocked": false
			},
			{
				"id": "163",
				"code": "584",
				"name": "МАРШАЛЛОВІ ОСТРОВИ",
				"caption": "МАРШАЛЛОВІ ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "137",
				"code": "484",
				"name": "МЕКСИКА",
				"caption": "МЕКСИКА",
				"isBlocked": false
			},
			{
				"id": "162",
				"code": "583",
				"name": "МІКРОНЕЗІЯ, ФЕДЕРАТИВНІ ШТАТИ",
				"caption": "МІКРОНЕЗІЯ, ФЕДЕРАТИВНІ ШТАТИ",
				"isBlocked": false
			},
			{
				"id": "143",
				"code": "508",
				"name": "МОЗАМБІК",
				"caption": "МОЗАМБІК",
				"isBlocked": false
			},
			{
				"id": "140",
				"code": "498",
				"name": "МОЛДОВА",
				"caption": "МОЛДОВА",
				"isBlocked": false
			},
			{
				"id": "138",
				"code": "492",
				"name": "МОНАКО",
				"caption": "МОНАКО",
				"isBlocked": false
			},
			{
				"id": "139",
				"code": "496",
				"name": "МОНГОЛІЯ",
				"caption": "МОНГОЛІЯ",
				"isBlocked": false
			},
			{
				"id": "141",
				"code": "500",
				"name": "МОНТСЕРРАТ",
				"caption": "МОНТСЕРРАТ",
				"isBlocked": false
			},
			{
				"id": "32",
				"code": "104",
				"name": "М'ЯНМА",
				"caption": "М'ЯНМА",
				"isBlocked": false
			},
			{
				"id": "145",
				"code": "516",
				"name": "НАМІБІЯ",
				"caption": "НАМІБІЯ",
				"isBlocked": false
			},
			{
				"id": "146",
				"code": "520",
				"name": "НАУРУ",
				"caption": "НАУРУ",
				"isBlocked": false
			},
			{
				"id": "0",
				"code": "Н/В",
				"name": "Н/В",
				"caption": "Н/В",
				"isBlocked": false
			},
			{
				"id": "147",
				"code": "524",
				"name": "НЕПАЛ",
				"caption": "НЕПАЛ",
				"isBlocked": false
			},
			{
				"id": "155",
				"code": "562",
				"name": "НІГЕР",
				"caption": "НІГЕР",
				"isBlocked": false
			},
			{
				"id": "156",
				"code": "566",
				"name": "НІГЕРІЯ",
				"caption": "НІГЕРІЯ",
				"isBlocked": false
			},
			{
				"id": "148",
				"code": "528",
				"name": "НІДЕРЛАНДИ",
				"caption": "НІДЕРЛАНДИ",
				"isBlocked": false
			},
			{
				"id": "149",
				"code": "530",
				"name": "НІДЕРЛАНДСЬКІ АНТИЛЬСЬКІ ОСТРОВИ",
				"caption": "НІДЕРЛАНДСЬКІ АНТИЛЬСЬКІ ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "154",
				"code": "558",
				"name": "НІКАРАГУА",
				"caption": "НІКАРАГУА",
				"isBlocked": false
			},
			{
				"id": "82",
				"code": "276",
				"name": "НІМЕЧЧИНА",
				"caption": "НІМЕЧЧИНА",
				"isBlocked": false
			},
			{
				"id": "157",
				"code": "570",
				"name": "НІУЕ",
				"caption": "НІУЕ",
				"isBlocked": false
			},
			{
				"id": "153",
				"code": "554",
				"name": "НОВА ЗЕЛАНДІЯ",
				"caption": "НОВА ЗЕЛАНДІЯ",
				"isBlocked": false
			},
			{
				"id": "151",
				"code": "540",
				"name": "НОВА КАЛЕДОНІЯ",
				"caption": "НОВА КАЛЕДОНІЯ",
				"isBlocked": false
			},
			{
				"id": "159",
				"code": "578",
				"name": "НОРВЕГІЯ",
				"caption": "НОРВЕГІЯ",
				"isBlocked": false
			},
			{
				"id": "227",
				"code": "834",
				"name": "ОБ'ЄДНАНА РЕСПУБЛІКА ТАНЗАНІЯ",
				"caption": "ОБ'ЄДНАНА РЕСПУБЛІКА ТАНЗАНІЯ",
				"isBlocked": false
			},
			{
				"id": "216",
				"code": "784",
				"name": "ОБ'ЄДНАНІ АРАБСЬКІ ЕМІРАТИ",
				"caption": "ОБ'ЄДНАНІ АРАБСЬКІ ЕМІРАТИ",
				"isBlocked": false
			},
			{
				"id": "144",
				"code": "512",
				"name": "ОМАН",
				"caption": "ОМАН",
				"isBlocked": false
			},
			{
				"id": "24",
				"code": "074",
				"name": "ОСТРІВ БУВЕ",
				"caption": "ОСТРІВ БУВЕ",
				"isBlocked": false
			},
			{
				"id": "158",
				"code": "574",
				"name": "ОСТРІВ НОРФОЛК",
				"caption": "ОСТРІВ НОРФОЛК",
				"isBlocked": false
			},
			{
				"id": "46",
				"code": "162",
				"name": "ОСТРІВ РІЗДВА",
				"caption": "ОСТРІВ РІЗДВА",
				"isBlocked": false
			},
			{
				"id": "182",
				"code": "654",
				"name": "ОСТРІВ СВЯТОЇ ЄЛЕНИ",
				"caption": "ОСТРІВ СВЯТОЇ ЄЛЕНИ",
				"isBlocked": false
			},
			{
				"id": "95",
				"code": "334",
				"name": "ОСТРІВ ХЕРД І ОСТРОВИ МАКДОНАЛЬД",
				"caption": "ОСТРІВ ХЕРД І ОСТРОВИ МАКДОНАЛЬД",
				"isBlocked": false
			},
			{
				"id": "39",
				"code": "136",
				"name": "ОСТРОВИ КАЙМАН",
				"caption": "ОСТРОВИ КАЙМАН",
				"isBlocked": false
			},
			{
				"id": "53",
				"code": "184",
				"name": "ОСТРОВИ КУКА",
				"caption": "ОСТРОВИ КУКА",
				"isBlocked": false
			},
			{
				"id": "205",
				"code": "744",
				"name": "ОСТРОВИ СВАЛЬБАРД ТА ЯН-МАЇН",
				"caption": "ОСТРОВИ СВАЛЬБАРД ТА ЯН-МАЇН",
				"isBlocked": false
			},
			{
				"id": "165",
				"code": "586",
				"name": "ПАКИСТАН",
				"caption": "ПАКИСТАН",
				"isBlocked": false
			},
			{
				"id": "164",
				"code": "585",
				"name": "ПАЛАУ",
				"caption": "ПАЛАУ",
				"isBlocked": false
			},
			{
				"id": "166",
				"code": "591",
				"name": "ПАНАМА",
				"caption": "ПАНАМА",
				"isBlocked": false
			},
			{
				"id": "96",
				"code": "336",
				"name": "ПАПСЬКИЙ ПРЕСТОЛ",
				"caption": "ПАПСЬКИЙ ПРЕСТОЛ",
				"isBlocked": false
			},
			{
				"id": "167",
				"code": "598",
				"name": "ПАПУА-НОВА ГВІНЕЯ",
				"caption": "ПАПУА-НОВА ГВІНЕЯ",
				"isBlocked": false
			},
			{
				"id": "168",
				"code": "600",
				"name": "ПАРАГВАЙ",
				"caption": "ПАРАГВАЙ",
				"isBlocked": false
			},
			{
				"id": "169",
				"code": "604",
				"name": "ПЕРУ",
				"caption": "ПЕРУ",
				"isBlocked": false
			},
			{
				"id": "199",
				"code": "710",
				"name": "ПІВДЕННА АФРИКА",
				"caption": "ПІВДЕННА АФРИКА",
				"isBlocked": false
			},
			{
				"id": "71",
				"code": "239",
				"name": "ПІВДЕННА ДЖОРДЖІЯ  ТА ПІВДЕННІ САНДВІЧЕВІ ОСТРОВИ",
				"caption": "ПІВДЕННА ДЖОРДЖІЯ  ТА ПІВДЕННІ САНДВІЧЕВІ ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "160",
				"code": "580",
				"name": "ПІВНІЧНІ МАРІАНСЬКІ ОСТРОВИ",
				"caption": "ПІВНІЧНІ МАРІАНСЬКІ ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "171",
				"code": "612",
				"name": "ПІТКЕРН",
				"caption": "ПІТКЕРН",
				"isBlocked": false
			},
			{
				"id": "172",
				"code": "616",
				"name": "ПОЛЬЩА",
				"caption": "ПОЛЬЩА",
				"isBlocked": false
			},
			{
				"id": "173",
				"code": "620",
				"name": "ПОРТУГАЛІЯ",
				"caption": "ПОРТУГАЛІЯ",
				"isBlocked": false
			},
			{
				"id": "176",
				"code": "630",
				"name": "ПУЕРТО-РИКО",
				"caption": "ПУЕРТО-РИКО",
				"isBlocked": false
			},
			{
				"id": "178",
				"code": "638",
				"name": "РЕЮНЬЙОН",
				"caption": "РЕЮНЬЙОН",
				"isBlocked": false
			},
			{
				"id": "180",
				"code": "643",
				"name": "РОСІЙСЬКА ФЕДЕРАЦІЯ",
				"caption": "РОСІЙСЬКА ФЕДЕРАЦІЯ",
				"isBlocked": false
			},
			{
				"id": "181",
				"code": "646",
				"name": "РУАНДА",
				"caption": "РУАНДА",
				"isBlocked": false
			},
			{
				"id": "179",
				"code": "642",
				"name": "РУМУНІЯ",
				"caption": "РУМУНІЯ",
				"isBlocked": false
			},
			{
				"id": "64",
				"code": "222",
				"name": "САЛЬВАДОР",
				"caption": "САЛЬВАДОР",
				"isBlocked": false
			},
			{
				"id": "235",
				"code": "882",
				"name": "САМОА",
				"caption": "САМОА",
				"isBlocked": false
			},
			{
				"id": "188",
				"code": "674",
				"name": "САН-МАРИНО",
				"caption": "САН-МАРИНО",
				"isBlocked": false
			},
			{
				"id": "189",
				"code": "678",
				"name": "САН-ТОМЕ І ПРІНСІПІ",
				"caption": "САН-ТОМЕ І ПРІНСІПІ",
				"isBlocked": false
			},
			{
				"id": "190",
				"code": "682",
				"name": "САУДІВСЬКА АРАВІЯ",
				"caption": "САУДІВСЬКА АРАВІЯ",
				"isBlocked": false
			},
			{
				"id": "206",
				"code": "748",
				"name": "СВАЗІЛЕНД",
				"caption": "СВАЗІЛЕНД",
				"isBlocked": false
			},
			{
				"id": "192",
				"code": "690",
				"name": "СЕЙШЕЛИ",
				"caption": "СЕЙШЕЛИ",
				"isBlocked": false
			},
			{
				"id": "191",
				"code": "686",
				"name": "СЕНЕГАЛ",
				"caption": "СЕНЕГАЛ",
				"isBlocked": false
			},
			{
				"id": "186",
				"code": "666",
				"name": "СЕН-П'ЄР І МІКЕЛОН",
				"caption": "СЕН-П'ЄР І МІКЕЛОН",
				"isBlocked": false
			},
			{
				"id": "187",
				"code": "670",
				"name": "СЕНТ-ВІНСЕНТ І ГРЕНАДІНИ",
				"caption": "СЕНТ-ВІНСЕНТ І ГРЕНАДІНИ",
				"isBlocked": false
			},
			{
				"id": "183",
				"code": "659",
				"name": "СЕНТ-КІТС І НЕВІС",
				"caption": "СЕНТ-КІТС І НЕВІС",
				"isBlocked": false
			},
			{
				"id": "185",
				"code": "662",
				"name": "СЕНТ-ЛЮСІЯ",
				"caption": "СЕНТ-ЛЮСІЯ",
				"isBlocked": false
			},
			{
				"id": "194",
				"code": "702",
				"name": "СІНГАПУР",
				"caption": "СІНГАПУР",
				"isBlocked": false
			},
			{
				"id": "209",
				"code": "760",
				"name": "СІРІЙСЬКА АРАБСЬКА РЕСПУБЛІКА",
				"caption": "СІРІЙСЬКА АРАБСЬКА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "195",
				"code": "703",
				"name": "СЛОВАЧЧИНА",
				"caption": "СЛОВАЧЧИНА",
				"isBlocked": false
			},
			{
				"id": "197",
				"code": "705",
				"name": "СЛОВЕНІЯ",
				"caption": "СЛОВЕНІЯ",
				"isBlocked": false
			},
			{
				"id": "28",
				"code": "090",
				"name": "СОЛОМОНОВІ ОСТРОВИ",
				"caption": "СОЛОМОНОВІ ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "198",
				"code": "706",
				"name": "СОМАЛІ",
				"caption": "СОМАЛІ",
				"isBlocked": false
			},
			{
				"id": "226",
				"code": "826",
				"name": "СПОЛУЧЕНЕ КОРОЛІВСТВО ВЕЛИКОБРИТАНІЯ",
				"caption": "СПОЛУЧЕНЕ КОРОЛІВСТВО ВЕЛИКОБРИТАНІЯ",
				"isBlocked": false
			},
			{
				"id": "228",
				"code": "840",
				"name": "СПОЛУЧЕНІ ШТАТИ АМЕРИКИ",
				"caption": "СПОЛУЧЕНІ ШТАТИ АМЕРИКИ",
				"isBlocked": false
			},
			{
				"id": "203",
				"code": "736",
				"name": "СУДАН",
				"caption": "СУДАН",
				"isBlocked": false
			},
			{
				"id": "204",
				"code": "740",
				"name": "СУРІНАМ",
				"caption": "СУРІНАМ",
				"isBlocked": false
			},
			{
				"id": "175",
				"code": "626",
				"name": "СХІДНИЙ ТІМОР",
				"caption": "СХІДНИЙ ТІМОР",
				"isBlocked": false
			},
			{
				"id": "193",
				"code": "694",
				"name": "СЬЄРРА-ЛЕОНЕ",
				"caption": "СЬЄРРА-ЛЕОНЕ",
				"isBlocked": false
			},
			{
				"id": "210",
				"code": "762",
				"name": "ТАДЖИКИСТАН",
				"caption": "ТАДЖИКИСТАН",
				"isBlocked": false
			},
			{
				"id": "211",
				"code": "764",
				"name": "ТАЇЛАНД",
				"caption": "ТАЇЛАНД",
				"isBlocked": false
			},
			{
				"id": "45",
				"code": "158",
				"name": "ТАЙВАНЬ, ПРОВІНЦІЯ  КИТАЮ",
				"caption": "ТАЙВАНЬ, ПРОВІНЦІЯ  КИТАЮ",
				"isBlocked": false
			},
			{
				"id": "220",
				"code": "796",
				"name": "ТЕРКС І КАЙКОС, ОСТРОВИ",
				"caption": "ТЕРКС І КАЙКОС, ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "212",
				"code": "768",
				"name": "ТОГО",
				"caption": "ТОГО",
				"isBlocked": false
			},
			{
				"id": "213",
				"code": "772",
				"name": "ТОКЕЛАУ",
				"caption": "ТОКЕЛАУ",
				"isBlocked": false
			},
			{
				"id": "214",
				"code": "776",
				"name": "ТОНГА",
				"caption": "ТОНГА",
				"isBlocked": false
			},
			{
				"id": "215",
				"code": "780",
				"name": "ТРИНІДАД І ТОБАГО",
				"caption": "ТРИНІДАД І ТОБАГО",
				"isBlocked": false
			},
			{
				"id": "221",
				"code": "798",
				"name": "ТУВАЛУ",
				"caption": "ТУВАЛУ",
				"isBlocked": false
			},
			{
				"id": "217",
				"code": "788",
				"name": "ТУНІС",
				"caption": "ТУНІС",
				"isBlocked": false
			},
			{
				"id": "218",
				"code": "792",
				"name": "ТУРЕЧЧИНА",
				"caption": "ТУРЕЧЧИНА",
				"isBlocked": false
			},
			{
				"id": "219",
				"code": "795",
				"name": "ТУРКМЕНІСТАН",
				"caption": "ТУРКМЕНІСТАН",
				"isBlocked": false
			},
			{
				"id": "222",
				"code": "800",
				"name": "УГАНДА",
				"caption": "УГАНДА",
				"isBlocked": false
			},
			{
				"id": "99",
				"code": "348",
				"name": "УГОРЩИНА",
				"caption": "УГОРЩИНА",
				"isBlocked": false
			},
			{
				"id": "232",
				"code": "860",
				"name": "УЗБЕКИСТАН",
				"caption": "УЗБЕКИСТАН",
				"isBlocked": false
			},
			{
				"id": "223",
				"code": "804",
				"name": "УКРАЇНА",
				"caption": "УКРАЇНА",
				"isBlocked": false
			},
			{
				"id": "234",
				"code": "876",
				"name": "УОЛЛІС І ФУТУНА",
				"caption": "УОЛЛІС І ФУТУНА",
				"isBlocked": false
			},
			{
				"id": "231",
				"code": "858",
				"name": "УРУГВАЙ",
				"caption": "УРУГВАЙ",
				"isBlocked": false
			},
			{
				"id": "69",
				"code": "234",
				"name": "ФАРЕРСЬКІ ОСТРОВИ",
				"caption": "ФАРЕРСЬКІ ОСТРОВИ",
				"isBlocked": false
			},
			{
				"id": "72",
				"code": "242",
				"name": "ФІДЖІ",
				"caption": "ФІДЖІ",
				"isBlocked": false
			},
			{
				"id": "170",
				"code": "608",
				"name": "ФІЛІППІНИ",
				"caption": "ФІЛІППІНИ",
				"isBlocked": false
			},
			{
				"id": "73",
				"code": "246",
				"name": "ФІНЛЯНДІЯ",
				"caption": "ФІНЛЯНДІЯ",
				"isBlocked": false
			},
			{
				"id": "70",
				"code": "238",
				"name": "ФОЛКЛЕНДСЬКІ ОСТРОВИ (МАЛЬВІНСЬКІ)",
				"caption": "ФОЛКЛЕНДСЬКІ ОСТРОВИ (МАЛЬВІНСЬКІ)",
				"isBlocked": false
			},
			{
				"id": "74",
				"code": "250",
				"name": "ФРАНЦІЯ",
				"caption": "ФРАНЦІЯ",
				"isBlocked": false
			},
			{
				"id": "75",
				"code": "254",
				"name": "ФРАНЦУЗЬКА ГВІАНА",
				"caption": "ФРАНЦУЗЬКА ГВІАНА",
				"isBlocked": false
			},
			{
				"id": "76",
				"code": "258",
				"name": "ФРАНЦУЗЬКА ПОЛІНЕЗІЯ",
				"caption": "ФРАНЦУЗЬКА ПОЛІНЕЗІЯ",
				"isBlocked": false
			},
			{
				"id": "77",
				"code": "260",
				"name": "ФРАНЦУЗЬКІ ПІВДЕННІ ТЕРИТОРІЇ",
				"caption": "ФРАНЦУЗЬКІ ПІВДЕННІ ТЕРИТОРІЇ",
				"isBlocked": false
			},
			{
				"id": "55",
				"code": "191",
				"name": "ХОРВАТІЯ",
				"caption": "ХОРВАТІЯ",
				"isBlocked": false
			},
			{
				"id": "40",
				"code": "140",
				"name": "ЦЕНТРАЛЬНОАФРИКАНСЬКА РЕСПУБЛІКА",
				"caption": "ЦЕНТРАЛЬНОАФРИКАНСЬКА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "42",
				"code": "148",
				"name": "ЧАД",
				"caption": "ЧАД",
				"isBlocked": false
			},
			{
				"id": "58",
				"code": "203",
				"name": "ЧЕСЬКА РЕСПУБЛІКА",
				"caption": "ЧЕСЬКА РЕСПУБЛІКА",
				"isBlocked": false
			},
			{
				"id": "43",
				"code": "152",
				"name": "ЧІЛІ",
				"caption": "ЧІЛІ",
				"isBlocked": false
			},
			{
				"id": "208",
				"code": "756",
				"name": "ШВЕЙЦАРІЯ",
				"caption": "ШВЕЙЦАРІЯ",
				"isBlocked": false
			},
			{
				"id": "207",
				"code": "752",
				"name": "ШВЕЦІЯ",
				"caption": "ШВЕЦІЯ",
				"isBlocked": false
			},
			{
				"id": "41",
				"code": "144",
				"name": "ШРІ-ЛАНКА",
				"caption": "ШРІ-ЛАНКА",
				"isBlocked": false
			},
			{
				"id": "237",
				"code": "891",
				"name": "ЮГОСЛАВІЯ",
				"caption": "ЮГОСЛАВІЯ",
				"isBlocked": false
			},
			{
				"id": "109",
				"code": "388",
				"name": "ЯМАЙКА",
				"caption": "ЯМАЙКА",
				"isBlocked": false
			},
			{
				"id": "110",
				"code": "392",
				"name": "ЯПОНІЯ",
				"caption": "ЯПОНІЯ",
				"isBlocked": false
			}
		],
	},
}
